import { BrowserRouter } from 'react-router'

import { AppRoutes } from '@/app/Router'

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}
